import PricingMatrix from '@/components/community_settings/PricingMatrix';

export default {
    key: 'pricing_matrix',
    title: 'pricing matrix',
    component: PricingMatrix,
    permissionChecker: () => true, // TODO: Needs permission?
};
